import { whatsappLink } from "../data/site";

export const WhatsAppFloat = () => (
  <a
    data-testid="whatsapp-float-btn"
    href={whatsappLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] hidden lg:flex items-center justify-center animate-pulse-ring hover:scale-110 transition-transform duration-300 shadow-2xl"
  >
    <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white" aria-hidden="true">
      <path d="M16 2.7C8.7 2.7 2.8 8.6 2.8 15.9c0 2.6.8 5 2.1 7L2.7 29.3l6.6-2.1c1.9 1.2 4.2 1.8 6.6 1.8 7.3 0 13.2-5.9 13.2-13.1S23.3 2.7 16 2.7zm0 23.9c-2.2 0-4.3-.6-6.1-1.8l-.4-.3-3.9 1.2 1.2-3.8-.3-.4c-1.3-1.9-2-4.2-2-6.5C4.5 9.5 9.7 4.4 16 4.4S27.5 9.5 27.5 15.9 22.3 26.6 16 26.6zm6.6-8.1c-.4-.2-2.1-1.1-2.5-1.2-.3-.1-.6-.2-.8.2-.2.4-.9 1.2-1.1 1.4-.2.2-.4.3-.8.1-.4-.2-1.5-.6-2.9-1.9-1.1-1-1.8-2.2-2-2.6-.2-.4 0-.6.2-.8l.6-.7c.2-.2.3-.4.4-.6.1-.2 0-.5 0-.6-.1-.2-.8-2.1-1.1-2.9-.3-.8-.6-.7-.8-.7h-.7c-.2 0-.6.1-1 .5-.3.4-1.2 1.2-1.2 3s1.3 3.5 1.5 3.7c.2.2 2.5 3.9 6.1 5.4.9.4 1.5.6 2.1.8.9.3 1.7.2 2.3.1.7-.1 2.1-.9 2.4-1.7.3-.9.3-1.6.2-1.7-.1-.2-.4-.3-.8-.5z" />
    </svg>
  </a>
);
